import Markdown from 'markdown-to-jsx';

export default function MarkdownView({ children }: { children: string }) {
  return (
    <div className="markdown-body text-sm text-gray-800">
      <Markdown options={{ disableParsingRawHTML: true, forceBlock: true }}>{children}</Markdown>
    </div>
  );
}
